import React from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from "../../layout/fullpage";
import { useFormik } from "formik";
import { useState } from "react";
import { MdEmail } from "react-icons/md";
import * as Yup from "yup";
import { signupApi } from "../../services/AuthService";
import { Spinner } from "react-bootstrap";
import image from "../../assets/images/bg-image/bg-image.jpg";
import image1 from "../../Images/bgimg1.png";
import { deptOptions } from "../../utilities";
import Select from "react-select";
import {
  Media,
  MediaGroup,
  Image,
  OverlineTitle,
  Logo,
} from "../../components";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
function AuthRegisterPage() {
  const [showPwd, setShowPwd] = useState(false);
  const [cshowPwd, setCshowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const phoneRegExp = /^[6-9]\d{9}$/;
  const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const navigate = useNavigate();
  const handlregister = async (payload) => {
    try {
      setLoading(true);
      const response = await signupApi(payload);
      formik.resetForm();
      toast.success("Register successfully");
      navigate("/");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required("First name is required"),

    last_name: Yup.string().required("Last name is required"),

    email: Yup.string()
      .matches(emailRegExp, "Invalid email format")
      .required("Email is required"),

    employee_id: Yup.string().required("Employee ID is required"),

    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),

    cpassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),

    gender: Yup.string().required("Gender is required"),

    mobile_number: Yup.string()
      .matches(phoneRegExp, "Enter a valid 10-digit mobile number")
      .required("Mobile number is required"),

    department: Yup.string().required("Department is required"),
  });
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      employee_id: "",
      password: "",
      cpassword: "",
      gender: "",
      mobile_number: "",
      department: "",
    },
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (value) => {
      const { cpassword, ...rest } = value;
      handlregister(rest);
    },
  });
  return (
    // <Layout title="Register" centered>
    <div className="d-flex align-items-center justify-content-center h-100 vw-100">
      <div className="my-responsive-box">
        {/* <Card className="w-100 overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh"> */}
        <Card className="h-100 w-100 overflow-auto">
          <Row className="h-100 w-100 g-0 flex-lg-row-reverse">
            <Col lg="5" style={{ padding: "20px" }}>
              <Card.Body className="h-100 d-flex flex-column justify-content-center">
                <div className="nk-block-head text-center">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title mb-1">Create New Account</h3>
                    <p className="small"></p>
                  </div>
                </div>
                <Form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">First Name</label>
                      <input
                        name="first_name"
                        type="text"
                        placeholder="John"
                        onChange={formik.handleChange}
                        className="form-control"
                        value={formik.values.first_name}
                      />
                      {formik.errors.first_name &&
                        formik.touched.first_name && (
                          <small style={{ color: "red" }}>
                            {formik.errors.first_name}
                          </small>
                        )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Last Name</label>
                      <input
                        name="last_name"
                        type="text"
                        placeholder="John"
                        onChange={formik.handleChange}
                        className="form-control"
                        value={formik.values.last_name}
                      />
                      {formik.errors.last_name && formik.touched.last_name && (
                        <small style={{ color: "red" }}>
                          {formik.errors.last_name}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Employee ID</label>
                      <input
                        name="employee_id"
                        type="text"
                        placeholder="EMP12345"
                        onChange={formik.handleChange}
                        className="form-control"
                        value={formik.values.employee_id}
                      />
                      {formik.errors.employee_id &&
                        formik.touched.employee_id && (
                          <small style={{ color: "red" }}>
                            {formik.errors.employee_id}
                          </small>
                        )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Phone Number</label>
                      <div className="position-relative">
                        <input
                          name="mobile_number"
                          type="text"
                          placeholder="8974847424"
                          onChange={formik.handleChange}
                          className="form-control px-5"
                          value={formik.values.mobile_number}
                          onBlur={formik.handleBlur}
                        />
                        <span className="position-absolute top-50 translate-middle-y text-primary fw-bold ms-2">
                          +91
                        </span>
                      </div>
                      {formik.errors.mobile_number &&
                        formik.touched.mobile_number && (
                          <small style={{ color: "red" }}>
                            {formik.errors.mobile_number}
                          </small>
                        )}
                    </div>
                    <div className="col-12 mb-1">
                      <label className="form-label">Email</label>
                      <div className="position-relative">
                        <input
                          name="email"
                          type="text"
                          placeholder="John@gmail.com"
                          onChange={formik.handleChange}
                          className="form-control px-5"
                          value={formik.values.email}
                          onBlur={formik.handleBlur}
                        />
                        <MdEmail
                          className="position-absolute top-50 translate-middle-y text-primary"
                          style={{ left: "15px", pointerEvents: "none" }}
                        />
                      </div>
                      {formik.errors.email && formik.touched.email && (
                        <small style={{ color: "red" }}>
                          {formik.errors.email}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Department</label>
                      <Select
                        className="react-select"
                        classNamePrefix="select"
                        options={deptOptions}
                        value={deptOptions.filter(
                          (data) => data.value == formik.values.department
                        )}
                        onChange={(selected) =>
                          formik.setFieldValue(
                            "department",
                            selected?.value || ""
                          )
                        }
                        isClearable
                      />
                      {/* <input
                        name="department"
                        type="text"
                        placeholder="Department"
                        onChange={formik.handleChange}
                        className="form-control"
                        value={formik.values.department}
                      /> */}
                      {formik.errors.department &&
                        formik.touched.department && (
                          <small style={{ color: "red" }}>
                            {formik.errors.department}
                          </small>
                        )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Gender</label>
                      <div className="d-flex gap-2">
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="gender"
                              value="male"
                              onChange={formik.handleChange}
                              checked={formik.values.gender === "male"}
                            />
                            <span className="ms-1">Male</span>
                          </label>
                        </div>
                        <div>
                          <label>
                            <input
                              type="radio"
                              name="gender"
                              value="female"
                              onChange={formik.handleChange}
                              checked={formik.values.gender === "female"}
                            />
                            <span className="ms-1">Female</span>
                          </label>
                        </div>
                      </div>
                      {formik.errors.gender && formik.touched.gender && (
                        <small style={{ color: "red" }}>
                          {formik.errors.gender}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Password</label>
                      <div className="position-relative">
                        <input
                          name="password"
                          type={showPwd ? "text" : "password"}
                          placeholder="*****"
                          className="form-control px-5"
                          onChange={formik.handleChange}
                          value={formik.values.password}
                        />
                        {/* Lock Icon (left) */}
                        <FaLock
                          className="position-absolute top-50 translate-middle-y text-primary"
                          style={{ left: "15px", pointerEvents: "none" }}
                        />
                        {/* Toggle Eye Icon (right) */}
                        <div
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() => setShowPwd((prev) => !prev)}
                        >
                          {!showPwd ? <FaEyeSlash /> : <FaEye />}
                        </div>
                      </div>
                      {formik.errors.password && formik.touched.password && (
                        <small style={{ color: "red" }}>
                          {formik.errors.password}
                        </small>
                      )}
                    </div>
                    <div className="col-12 col-sm-6 mb-1">
                      <label className="form-label">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          name="cpassword"
                          type={cshowPwd ? "text" : "password"}
                          placeholder="*****"
                          className="form-control px-5"
                          onChange={formik.handleChange}
                          value={formik.values.cpassword}
                          onBlur={formik.handleBlur}
                        />
                        {/* Lock Icon (left) */}
                        <FaLock
                          className="position-absolute top-50 translate-middle-y text-primary"
                          style={{ left: "15px", pointerEvents: "none" }}
                        />
                        {/* Toggle Eye Icon (right) */}
                        <div
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() => setCshowPwd((prev) => !prev)}
                        >
                          {!cshowPwd ? <FaEyeSlash /> : <FaEye />}
                        </div>
                      </div>
                      {formik.errors.cpassword && formik.touched.cpassword && (
                        <small style={{ color: "red" }}>
                          {formik.errors.cpassword}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" />
                            <span className="ms-1">Loading</span>
                          </>
                        ) : (
                          "Signup"
                        )}
                      </button>
                    </div>
                  </div>
                </Form>
                {/* <div className="my-3 text-center">
                  <OverlineTitle className="overline-title-sep">
                    <span>OR</span>
                  </OverlineTitle>
                </div>
                <Row className="g-2">
                  <Col xxl="6">
                    <Button
                      href="#auth"
                      variant="outline-light"
                      className="w-100"
                    >
                      <Image src="/images/icon/d.png" alt="" className="icon" />
                      <span className="fw-medium">Continue with Google</span>
                    </Button>
                  </Col>
                  <Col xxl="6">
                    <Button
                      href="#auth"
                      variant="outline-light"
                      className="w-100"
                    >
                      <Image src="/images/icon/b.png" alt="" className="icon" />
                      <span className="fw-medium">Continue with Facebook</span>
                    </Button>
                  </Col>
                </Row> */}
                <div className="text-center mt-4">
                  <p className="small">
                    Already have an account? <Link to="/">Login</Link>
                  </p>
                </div>
              </Card.Body>
            </Col>
            <div className="d-none d-lg-block col-lg-7">
              <Card.Body
                className="is-theme has-mask has-mask-1 h-100 d-flex flex-column justify-content-end"
                style={{
                  backgroundImage: `url(${image1})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
                centered
              >
                {/* <div className="brand-logo">
                  <Logo />
                </div> */}
                <div className="row">
                  <div className="col-sm-11">
                    <div className="mt-4">
                      {/* <div className="h1 title mb-3">
                        Welcome to <br /> InteliShuttle
                      </div>
                      <p>
                        Experience smarter Bus Pass management and seamless
                        operations to enhance productivity and efficiency.
                      </p> */}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </div>
          </Row>
        </Card>
        {/* </Card> */}
      </div>
    </div>
    // </Layout>
  );
}

export default AuthRegisterPage;
